import PropTypes from 'prop-types'
import React from 'react'
import { CollectionItem } from '../CollectionProducts/theme'
import CollectionWithHeader from '../CollectionWithHeader'
import Frame from '../Frame'

const CollectionFrames = ({ title = '', errMessage, isLoading, frames = [], onClick, onZoom, perMeter }) => (
  <CollectionWithHeader title={title} errMessage={errMessage} isLoading={isLoading}>
    {frames.sort((a, b) => a.showOrder - b.showOrder).map(({ name, label, preview, borderWidth }) => (
      <CollectionItem key={name} onClick={() => onClick(name, borderWidth, label)}>
        <Frame
          width={30}
          height={20}
          frame={name}
          text={label}
          perMeter={perMeter}
          borderWidth={borderWidth}
          preview={`/borders/${label}_demo.jpg`}
          onZoom={onZoom}
        />
      </CollectionItem>
    ))}
  </CollectionWithHeader>
)

CollectionFrames.propTypes = {
  title: PropTypes.string,
  errMessage: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  frames: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      borderWidth: PropTypes.number,
      preview: PropTypes.string,
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  perMeter: PropTypes.number.isRequired,
}

export default CollectionFrames



// WEBPACK FOOTER //
// ./src/components/CollectionFrames/index.js